import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleToggleCollapsed,
  handleSetSelectedContentBasedValues,
  handleChangeSortBy,
  handleSetPublishRateValue,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './resourceHelpers';
import { nativePlatformsFiltersInitialState } from './initialState/nativePlatformsInitialState';

export { nativePlatformsFiltersInitialState as filtersInitialState };

export const nativePlatformsSearchResourceInitialState = {
  filters: nativePlatformsFiltersInitialState,
  sortBy: {
    selected: 'member_count',
    order: 'desc',
  },
  selectedFilter: 'contentBasedFilter',
};
export const nativePlatformsSearchResourceSlice = createSlice({
  name: 'nativePlatformSearchResourceSlice',
  initialState: nativePlatformsSearchResourceInitialState,
  reducers: {
    setSelectedContentBasedValues: (state, action) => {
      handleSetSelectedContentBasedValues(state, action);
    },
    setPublishRateValue: (state, action) => {
      handleSetPublishRateValue(state, action);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = nativePlatformsFiltersInitialState;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, nativePlatformsFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedContentBasedValues,
  setSelectedFilterValue,
  setPublishRateValue,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
} = nativePlatformsSearchResourceSlice.actions;
